module.exports = __webpack_public_path__ + "static/img/kb-card-app-main-img-01@t.3834d35.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/kb-card/kb-card-app-main-img-01@t.png
// module id = 9k/R
// module chunks = 0